import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';



@Injectable()
export class WindowDetailEffects {



  constructor(private actions$: Actions) {}

}
